import { useState } from "react";

const testimonies = [
  {
    name: "Sunaina Chaudhary",
    place: "Delhi",
    image: "/Images/sunaina.jpeg",
    short:
      "Born into a Hindu family, I found true love and peace through Jesus Christ...",
    full: `My name is Sunaina Chaudhary. I was born and raised in a Hindu family, surrounded by traditions and rituals from an early age. As a child, I was never deeply drawn toward idol worship, even though I continued to follow my family’s customs.

When I was around 12–13 years old, my life took a turning point. I came to know about Jesus Christ, and through Him, I experienced a love and peace that I had never known before. Gradually, my faith in Jesus and His Word—the Bible—began to grow stronger.

As my faith grew, I began to face severe opposition. My family members and relatives accused me of converting to Christianity. I was abused, beaten, and humiliated, and rituals were even performed against me. Eventually, the situation became so dangerous that plans were made to take my life.

For nearly five years, I lived through fear, pain, and darkness. Yet during those difficult years, I experienced an unexplainable protection and strength with me at all times. I truly believe that God was watching over me and shielding me.

Through these trials, one truth became clear to me:

Jesus Christ is the true and living God.  
There is no one like Him, and there never will be.

Even today, I continue to experience God’s presence in my life. He has saved me from my sins, healed me from my past wounds, and given me hope, purpose, and a new life in Jesus Christ.

Thank You, Lord.  
Amen.`,
  },
  

  {
    name: "Reena Shrivastava",
    place: "India",
    image: "/Images/reena-testimony.jpeg",
    short:
      "I thank the Lord for the miraculous healing and blessings in my family...",
    full: `मेरा नाम रीना श्रीवास्तव है। मैं अपने प्रभु परमेश्वर का धन्यवाद करती हूँ, क्योंकि उन्होंने मेरे जीवन और मेरे परिवार में अनेक अद्भुत कार्य किए हैं।

सबसे पहले, मैं प्रभु का धन्यवाद करती हूँ कि उन्होंने मेरी बेटी मानसी के जीवन में अद्भुत चंगाई दी। उसकी आँखों में गंभीर समस्या थी। आज प्रभु की कृपा से उसकी आँखों में कोई समस्या नहीं है।

दूसरी गवाही मेरे पति के विषय में है। डॉक्टरों ने कहा था कि वह कैंसर हो सकता है, लेकिन प्रभु की कृपा से सभी रिपोर्ट सामान्य आईं।

तीसरी गवाही मेरे अपने जीवन से जुड़ी है। मैं लंबे समय तक बीमार रही, लेकिन अब प्रभु की दया से स्वस्थ हूँ। एक समय ऐसा भी था जब मेरे पास कोई नौकरी नहीं थी, लेकिन प्रभु ने एक साथ दो नौकरियाँ प्रदान कीं।

सारी महिमा परमेश्वर को।  
आमीन।`,
  },

  {
    name: "Ramkumar Patel",
    place: "Ex-Army Subedar",
    image: "/Images/ram-patel-testimont.jpeg",
    short:
      "Alcohol destroyed my family, but Jesus Christ completely changed my life...",
    full: `मेरा नाम रामकुमार पटेल है। मैं एक हिंदू परिवार से हूँ और Ex-Army Subedar के रूप में सेवाकनिवृत्त हूँ।

एक समय हमारे परिवार की आर्थिक स्थिति बहुत कमजोर थी और मेरे जीवन में शराब की बुरी आदत लग गई थी, जिसके कारण मेरी पत्नी और बच्चों को बहुत कष्ट सहना पड़ा।

मेरे तीन बेटे हैं। एक दिन मेरा छोटा बेटा अचानक गंभीर रूप से बीमार हो गया। किसी भी प्रकार का इलाज असर नहीं कर रहा था। उसी समय हमारी कॉलोनी में रहने वाली एक सिस्टर हमारे घर आईं और मेरे बेटे के लिए प्रार्थना की।  
15–20 मिनट के भीतर मेरा बेटा पूरी तरह ठीक हो गया।

इस अद्भुत चंगाई के द्वारा प्रभु ने मेरे जीवन को छू लिया। उसी दिन मैंने शराब पीना छोड़ दिया और प्रभु यीशु मसीह को अपने जीवन में स्वीकार किया। उस दिन के बाद से मेरा जीवन पूरी तरह बदल गया।

प्रभु यीशु ने मेरे परिवार में सच्ची खुशी, शांति और एकता भर दी।

आज मेरा बड़ा बेटा परमेश्वर की सेवकाई में कार्य कर रहा है, और मेरे दोनों अन्य बेटे भी अपने-अपने जीवन में स्थिर हैं तथा किसी न किसी रूप में प्रभु की सेवा में जुड़े हुए हैं।

इसके साथ ही, आज मैं स्वयं अपनी पत्नी के साथ मिलकर प्रभु की सेवकाई में एक सुसमाचार प्रचारक (Evangelist) के रूप में सेवा कर रहा हूँ। परमेश्वर ने हमारे जीवन का उपयोग अनेक लोगों को प्रेरित करने और उनके जीवन में आशीषें लाने के लिए किया है।

मैं पूरे विश्वास के साथ कह सकता हूँ कि यीशु मसीह जीवित प्रभु हैं।  
सारी महिमा परमेश्वर को।  
आमीन।`,
  },
  {
  name: "Sapna",
  place: "India",
  image: "/Images/sapna-testimony.jpeg",
  short:
    "My life was full of struggles, but through Jesus Christ, I found peace, healing, and a new purpose...",
  full: `मेरी गवाही का नाम है — “परमेश्वर ने मेरे जीवन को बदल दिया”।

मेरा नाम सपना है। पहले मेरा जीवन बहुत संघर्षों से भरा हुआ था। परिवार में कई तरह की परेशानियाँ थीं — आर्थिक दबाव, रिश्तों में तनाव और मन में भारीपन। उस समय मुझे लगता था कि मेरे सवालों के कोई जवाब नहीं हैं और जीवन में शांति नहीं है।

उसी समय किसी ने मुझे यीशु के बारे में बताया और प्रार्थना सभा में आने के लिए आमंत्रित किया। पहली बार जब मैंने परमेश्वर का वचन सुना, तो मेरे दिल को एक अजीब-सी शांति मिली। मैंने नियमित रूप से प्रार्थना करना और बाइबल पढ़ना शुरू किया और धीरे-धीरे समझने लगी कि प्रभु यीशु ही मेरे जीवन का सच्चा सहारा हैं।

कुछ समय बाद हमारे परिवार में बड़ी बीमारी और आर्थिक संकट आया। मानव दृष्टि से स्थिति बहुत कठिन थी, लेकिन हमने हार नहीं मानी। हम सबने मिलकर प्रार्थना की और प्रभु पर पूरा भरोसा रखा।

उसी समय परमेश्वर ने अद्भुत रीति से कार्य किया — बीमारी से चंगाई मिली, घर में शांति लौटी और हमारी परिस्थितियाँ बदलने लगीं।

आज मैं पूरे विश्वास के साथ गवाही देती हूँ कि प्रभु यीशु जीवित हैं और वह प्रार्थना सुनते हैं। उन्होंने मेरे परिवार को संभाला, मुझे नया साहस दिया और मेरे जीवन को एक नया उद्देश्य दिया।

आज मैं प्रभु की सेवा में जुड़ी हुई हूँ और जहाँ भी अवसर मिलता है, लोगों को यह बताती हूँ कि यीशु ही आशा और शांति का स्रोत हैं।

सारी महिमा केवल प्रभु यीशु मसीह के नाम को।  
आमीन।`,
}


];
 
export default function Testimonies() {
  const [activeTestimony, setActiveTestimony] = useState(null);

  return (
    <section className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-6 py-14 rounded-t-3xl">
      <h2 className="text-3xl font-bold text-center mb-10">
        Powerful Testimonies
      </h2>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
        {testimonies.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-xl p-6 border-l-4 border-[#D9A05B]"
          >
            {/* Image + Name aligned */}
            <div className="flex items-center gap-4 mb-3">
              <img
                src={item.image}
                 alt={`${item.name} from ${item.place} sharing testimony in Moriah Church`} 
                className="w-14 h-14 rounded-full object-cover border-2 border-[#D9A05B]"
              />
              <div>
                <h3 className="text-xl font-bold">{item.name}</h3>
                <p className="text-sm text-gray-500">{item.place}</p>
              </div>
            </div>

            <p className="text-lg leading-relaxed mb-4">
              “{item.short}”
            </p>

            <button
              onClick={() => setActiveTestimony(item)}
              className="text-[#D9A05B] font-semibold hover:underline"
            >
              Read More →
            </button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {activeTestimony && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
          <div className="bg-white max-w-lg w-full rounded-2xl p-6 relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setActiveTestimony(null)}
              className="absolute top-3 right-4 text-2xl font-bold text-gray-600 hover:text-black"
            >
              ×
            </button>

            <div className="flex items-center gap-4 mb-4">
              <img
                src={activeTestimony.image}
                alt={`${activeTestimony.name} from ${activeTestimony.place} sharing testimony in Moriah Church`}
                className="w-14 h-14 rounded-full object-cover border-2 border-[#D9A05B]"
              />
              <div>
                <h3 className="text-xl font-bold">
                  {activeTestimony.name}
                </h3>
                <p className="text-sm text-gray-500">
                  {activeTestimony.place}
                </p>
              </div>
            </div>

            <div className="space-y-4 text-lg leading-relaxed whitespace-pre-line">
              {activeTestimony.full}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
